
  import { defineComponent } from 'vue';
  import { Tooltip } from '@/ui/components/Tooltip';
  import { Button } from '@/ui/components/Button';
  import { Icon } from '@/ui/components/icon/Icon';
  import { SupportedExportFormat } from '@/services/api/resources/analytics';

  interface ReportExportProps {
    loading: boolean;
    disabled: boolean;
  }

  export default defineComponent<ReportExportProps>({
    components: {
      Tooltip,
      Button,
      Icon,
    },
    props: ['loading', 'disabled'],
    emits: ['export'],
    setup(_, { emit }) {
      const onClickExport = (format: SupportedExportFormat) => {
        emit('export', format);
      };

      return {
        onClickExport,
      };
    },
  });
